import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { useParams } from "react-router-dom";
import Select from "react-dropdown-select";
import axios from "axios";
import { emit } from "process";
const token = localStorage.getItem('authToken');
class EditMatrimony extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

            textInput: [],
            id: "",
            refCode: "",
            userName: "",
            emailInput: "",
            state: "",
            city: "",
            pinCode: "",
            bloodGroup: "",
            nativeOf: "",
            district: "",
            kulName: "",
            categoryData: [],
            existingImages: [],
            currentImageUrls: [],
            errors: [],
            submissionStatus: null,
            
            submissionStatus: null,
            submeet: false,
            errors: [],
            caste: "",
            subcaste: "",
            bodyColor: "",
            gotra: "",
            areaInput: "",
            firmName: "",
            firmAddress: "",
            dealsWith: "",
            contact: "",
            website: "",

            martitalStatus: "",
            categoryId: null, // Track the original category ID
            categoryChanged: false,
            maxSize: 5 * 1024 * 1024, // 5MB in bytes
           
            category: "",
            categoryData: [],
            selectedJobCategories: [],

       

          
            bloodDonate: "",
            selectedJobCategories: [],
        };
        this.handleBloodDonateChange = this.handleBloodDonateChange.bind(this);
        // this.setState({ gender: this.state.userData?.gender || '' });
        this.setState({ martitalStatus: this.state.userData?.martitalStatus || '' });
        this.handleManglikChange = this.handleManglikChange.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    async componentDidMount() {
        const { match } = this.props;
        const { id } = match.params;
        this.setState({ id });
        this.fetchData(id);
        this.fetchDataCategory();

    }

    fetchData = async (id) => {
        try {
            const response = await axios.get(`https://samaj.aasmo.in/api/admin/matrimony/${id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            const userData = response?.data?.data;
            console.log(userData);

            // Convert date of birth from ISO format to YYYY-MM-DD format for input field
            const dateOfBirth = userData?.dateOfBirth ? new Date(userData.dateOfBirth).toISOString().split('T')[0] : '';

            this.setState({
                userName: userData?.userName,
                fullName: userData.fullName,
                fathersName: userData?.fathersName,

                gender: userData?.gender || '',
                martitalStatus: userData?.maritalStatus || '',
                fathersContact: userData?.fatherMobile,
                existingImages: userData?.images || [],
                noOfBrothers: userData?.numOfBrothers,
                noOfSister: userData?.numOfSisters,

                manglikCheck: userData?.manglik ? 'true' : 'false',

                bodyColor: userData?.bodyColor || '',

                height: userData?.height,
                bloodGroup: userData?.bloodGroup || '',

                dateInput: dateOfBirth, // Set dateInput with formatted date of birth

                birthTime: userData?.birthTime,

                areaInput: userData?.address,
                mobileNo: userData?.mobileNo,
                city: userData?.city,
                education: userData?.education,
                subcaste: userData?.subcaste || '',
                profession: userData?.profession,
                expectation: userData?.expectation,
                perAnnum: userData?.perAnnum,
                gotra: userData?.gotra,
                state: userData?.state,
                pinCode: userData?.pincode,
                about: userData?.about,
                //    category : userData?.packageName?.id || ''
                category: userData?.packageName?.title,
                categoryId: userData?.packageName?._id,
            });
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };


    fetchDataCategory = async () => {
        try {
            const response = await axios.get(`https://samaj.aasmo.in/api/admin/matrimonypackages`);
            console.log(response.data);
            if (response.data) {
                this.setState({ categoryData: response.data?.data });
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };
    handleChange = (e) => {
        const files = Array.from(e.target.files);
        const errors = [];
    
        const selectedImages = files.filter((file) => {
            const isValidSize = file.size <= this.state.maxSize;
            if (!isValidSize) {
                errors.push(`${file.name} is too large, please select a file smaller than 5MB.`);
            }
            return isValidSize;
        });
    
        this.setState({
            textInput: selectedImages,
            currentImageUrls: selectedImages.map((file) => URL.createObjectURL(file)),
            errors,
        });
    };

    handleCategoryChange = (e) => {
        const selectedCategoryId = e.target.value;
        console.log("Selected Category ID:", selectedCategoryId);
        console.log("Current categoryData:", this.state.categoryData);

        const selectedCategory = this.state.categoryData.find(category => category.id.toString() === selectedCategoryId);

        if (selectedCategory) {
            this.setState({
                category: selectedCategory.name,
                categoryId: selectedCategory.id,
                categoryChanged: true,
            });
        } else {
            console.error(`Category with ID ${selectedCategoryId} not found`);
        }
    };
    handlebodyColorChange = (e) => {
        this.setState({ bodyColor: e.target.value });
    };
    handleSubcasteChange = (e) => {
        this.setState({ subcaste: e.target.value });
    };
    getCurrentDate = () => {
        const currentDate = new Date().toISOString().slice(0, 10);
        return currentDate;
    };

    // Function to handle input change
    handleInputChange = (e) => {
        this.setState({ dateInput: e.target.value });
    };

    handleBloodDonateChange(e) {
        this.setState({ bloodDonate: e.target.value });
    }

    handleNativeOfChange = (e) => {
        const nativeOf = e.target.value;
        this.setState({ nativeOf, district: "", city: "" });
    };

    handleDistrictChange = (e) => {
        const district = e.target.value;
        this.setState({ district, city: "" });
    };
    handleMartitalStatusChange = (e) => {
        this.setState({ martitalStatus: e.target.value });
    };


    handleCityChange = (e) => {
        const homeCity = e.target.value;
        this.setState({ homeCity });
    };





    handleGotraChange = (e) => {
        const gotra = e.target.value;
        this.setState({ gotra });
    };
    handlegenderChange = (e) => {
        this.setState({ gender: e.target.value });
    };



    handleManglikChange = (e) => {
        this.setState({ manglikCheck: e.target.value });
    };


    handleSubmit = async (e) => {
        e.preventDefault();
        const { id } = this.props.match.params;

        try {
            const {

                textInput,

                emailInput,
                areaInput,
                about,
                userName,
                fullName,
                fathersName,
                state,
                city,
                pinCode,
                bloodGroup,
                gender,
                manglikCheck,



                expectation,
                height,
                kulName,
                caste,
                perAnnum,
                gotra,
                education,
                firmName,
                firmAddress,
                martitalStatus,
                profession,
                bodyColor,
                mobileNo,
                existingImages,
                currentImageUrl,
                fathersContact,
                noOfBrothers,
                noOfSister,
                website,
                subcaste,
                category, categoryId,
                dateInput,
                birthTime,
            } = this.state;

            const formData = new FormData();
            if (textInput.length > 0) {
                textInput.forEach((file) => {
                    formData.append('images', file);
                });
            } else {
                existingImages.forEach((url) => {
                    formData.append('existingImages', url);
                });
            }
            formData.append('address', areaInput);
            formData.append('about', about);
            formData.append('city', city);
            formData.append('userName', userName);
            formData.append('fullName', fullName);
            formData.append('fathersName', fathersName);
            formData.append('gotra', gotra);
            formData.append('education', education);
            formData.append('state', state);
            formData.append('dateOfBirth', dateInput);
            formData.append('birthTime', birthTime);
            formData.append('pincode', pinCode);
            formData.append('bloodGroup', bloodGroup);
            formData.append('gender', gender);
            formData.append('manglik', this.state.manglikCheck);

            formData.append('expectation', expectation);
            formData.append('height', height);

            formData.append('subcaste', subcaste);
            formData.append('perAnnum', perAnnum);
            formData.append('packageName', categoryId)
            formData.append('martitalStatus', martitalStatus);
            formData.append('profession', profession);
            formData.append('bodyColor', bodyColor);
            formData.append('mobileNo', mobileNo);
            formData.append('fatherMobile', fathersContact);
            formData.append('numOfBrothers', noOfBrothers);
            formData.append('numOfSisters', noOfSister);

            const config = {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${token}`,
                }
            };

            const response = await axios.put(`https://samaj.aasmo.in/api/admin/matrimony/${id}`, formData, config);

            if (response.status === 200) {
                this.setState({ submissionStatus: 'success' });
                setTimeout(() => {
                    this.props.history.push ("/matrimonylist");
                }, 2000);
            }

            console.log(response, "==>res");
        } catch (error) {
            console.log(error);
        }
    };
    handleOccupationChange = (event) => {
        const { value } = event.target;
        this.setState({ selectedJobCategories: [value] });
    };



    render() {
        const { textInput, existingImages,errors ,categoryData, categoryId, currentImageUrls, refCode, emailInput, areaInput, submeet, about, fullName, fathersName, userName, state, city, pinCode, bloodGroup, nativeOf, district, kulName, perAnnum, subcaste, gotra, education, firmName, firmAddress, martitalStatus, profession, bodyColor, mobileNo, fathersContact, noOfBrothers, noOfSister, website, gender, manglik, homeCity, expectation, height, dateInput, birthTime, submissionStatus, manglikCheck
        } = this.state;
        const reg = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
        return (
            <div className="col-md-12">
                <div className="card">
                    <div className="header">
                        <h2>Edit Matrimony</h2>
                    </div>
                    <div className="body">
                        <form className="ng-untouched ng-dirty ng-invalid">
                            <div className="form-group">
                                <label>UserName</label>
                                <input
                                    className={`form-control ${!reg.test(userName) && submeet && "parsley-error"
                                        }`}
                                    value={userName}
                                    name="userName"
                                    pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$"
                                    required=""
                                    type="text"
                                    onChange={(e) => {
                                        this.setState({ userName: e.target.value });
                                    }}
                                />
                                {submeet && !reg.test(userName) ? (
                                    <ul className="parsley-errors-list filled" id="parsley-id-29">
                                        <li className="parsley-required">
                                            This value is required.
                                        </li>
                                    </ul>
                                ) : null}
                            </div>
                            <div className="form-group">
                                <label>Full Name</label>
                                <input
                                    className={`form-control ${!reg.test(userName) && submeet && "parsley-error"
                                        }`}
                                    value={fullName}
                                    name="fullName"
                                    pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$"
                                    required=""
                                    type="text"
                                    onChange={(e) => {
                                        this.setState({ fullName: e.target.value });
                                    }}
                                />
                                {submeet && !reg.test(fullName) ? (
                                    <ul className="parsley-errors-list filled" id="parsley-id-29">
                                        <li className="parsley-required">
                                            This value is required.
                                        </li>
                                    </ul>
                                ) : null}
                            </div>
                            <div className="form-group">
                                <label>Father's Name</label>
                                <input
                                    className={`form-control ${!reg.test(userName) && submeet && "parsley-error"
                                        }`}
                                    value={fathersName}
                                    name="fathersName"
                                    pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$"
                                    required=""
                                    type="text"
                                    onChange={(e) => {
                                        this.setState({ fathersName: e.target.value });
                                    }}
                                />
                                {submeet && !reg.test(fathersName) ? (
                                    <ul className="parsley-errors-list filled" id="parsley-id-29">
                                        <li className="parsley-required">
                                            This value is required.
                                        </li>
                                    </ul>
                                ) : null}
                            </div>
                            <div className="form-group">
                                <label>Gender</label>
                                <br />
                                <label className="fancy-radio">
                                    <input
                                        name="gender"
                                        type="radio"
                                        value="Male"
                                        onChange={this.handlegenderChange}
                                        checked={gender === 'Male'}
                                    />
                                    <span>
                                        <i></i>Male
                                    </span>
                                </label>
                                <label className="fancy-radio">
                                    <input
                                        name="gender"
                                        type="radio"
                                        value="Female"
                                        onChange={this.handlegenderChange}
                                        checked={gender === 'Female'}
                                    />
                                    <span>
                                        <i></i>Female
                                    </span>
                                </label>
                                <label className="fancy-radio">
                                    <input
                                        name="gender"
                                        type="radio"
                                        value="Other"
                                        onChange={this.handlegenderChange}
                                        checked={gender === 'Other'}
                                    />
                                    <span>
                                        <i></i>Other
                                    </span>
                                </label>
                            </div>
                            <div className="form-group">
                                <label>Martital Status</label>
                                <select
                                    className="form-control"
                                    value={martitalStatus}
                                    name="martitalStatus"
                                    onChange={this.handleMartitalStatusChange}
                                >
                                    <option value="">{martitalStatus}</option>
                                    <option value="Single">Single</option>
                                    <option value="Married">Married</option>
                                    <option value="Divorced">Divorced</option>
                                    <option value="Widowed">Widowed</option>
                                    {/* Add more options for caste */}
                                </select>
                            </div>
                            <div className="form-group">
                                <label>Father's Contact No </label>
                                <input
                                    className={`form-control ${!reg.test(fathersContact) && submeet && "parsley-error"
                                        }`}
                                    value={fathersContact}
                                    name="fathersContact"
                                    pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$"
                                    // required=""
                                    type="number"
                                    onChange={(e) => {
                                        this.setState({ fathersContact: e.target.value });
                                    }}
                                />

                            </div>
                            <div className="form-group">
                                <label>No. Of Brother's </label>
                                <input
                                    className={`form-control ${!reg.test(noOfBrothers) && submeet && "parsley-error"
                                        }`}
                                    value={noOfBrothers}
                                    name="noOfBrothers"
                                    pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$"
                                    // required=""
                                    type="number"
                                    onChange={(e) => {
                                        this.setState({ noOfBrothers: e.target.value });
                                    }}
                                />

                            </div>
                            <div className="form-group">
                                <label>No. Of Sister's </label>
                                <input
                                    className={`form-control ${!reg.test(noOfSister) && submeet && "parsley-error"
                                        }`}
                                    value={noOfSister}
                                    name="noOfSister"
                                    pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$"
                                    // required=""
                                    type="number"
                                    onChange={(e) => {
                                        this.setState({ noOfSister: e.target.value });
                                    }}
                                />

                            </div>
                            <div className="form-group">
                                <label>Manglik</label>
                                <br />
                                <label className="fancy-radio">
                                    <input
                                        data-parsley-errors-container="#error-radio"
                                        name="manglikCheck"
                                        type="radio"
                                        value="true"
                                        onChange={this.handleManglikChange}
                                        checked={manglikCheck === 'true'}
                                    />
                                    <span>
                                        <i></i>Manglik
                                    </span>
                                </label>
                                <label className="fancy-radio">
                                    <input
                                        name="manglikCheck"
                                        type="radio"
                                        value="false"
                                        onChange={this.handleManglikChange}
                                        checked={manglikCheck === 'false'}
                                    />
                                    <span>
                                        <i></i>Non-Manglik
                                    </span>
                                </label>
                            </div>

                            <div className="form-group">
                                <label>Body Colour</label>
                                <select
                                    className="form-control"
                                    value={bodyColor}
                                    name="bodyColor"
                                    onChange={this.handlebodyColorChange}
                                >
                                    <option value="">{bodyColor}</option>
                                    <option value="Fair">Fair</option>
                                    <option value="Wheatish">Wheatish</option>
                                    <option value="Dusky">Dusky</option>
                                    <option value="Black">Black</option>
                                    {/* Add more options for caste */}
                                </select>
                            </div>
                            <div className="form-group">
                                <label>Height</label>
                                <input
                                    className={`form-control ${!reg.test(height) && submeet && "parsley-error"
                                        }`}
                                    value={height}
                                    name="height"
                                    pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$"
                                    required=""
                                    type="text"
                                    onChange={this.handleChange}
                                />
                                {submeet && !reg.test(height) ? (
                                    <ul className="parsley-errors-list filled" id="parsley-id-29">
                                        <li className="parsley-required">
                                            This value is required.
                                        </li>
                                    </ul>
                                ) : null}
                            </div>
                            <div className="form-group">
                                <label htmlFor="bloodGroup">Blood Group</label>
                                <select
                                    className={`form-control ${submeet && !bloodGroup && "parsley-error"}`}
                                    value={bloodGroup}
                                    name="bloodGroup"
                                    required=""
                                    onChange={(e) => {
                                        this.setState({ bloodGroup: e.target.value });
                                    }}
                                >

                                    <option value="A+">A+</option>
                                    <option value="A-">A-</option>
                                    <option value="B+">B+</option>
                                    <option value="B-">B-</option>
                                    <option value="AB+">AB+</option>
                                    <option value="AB-">AB-</option>
                                    <option value="O+">O+</option>
                                    <option value="O-">O-</option>
                                </select>
                                {submeet && !bloodGroup ? (
                                    <ul className="parsley-errors-list filled" id="parsley-id-29">
                                        <li className="parsley-required">Blood group is required.</li>
                                    </ul>
                                ) : null}
                            </div>

                            <div className="form-group">
                                <label>Date Of Birth</label>
                                <input
                                    className={`form-control ${!reg.test(dateInput) && submeet && "parsley-error"}`}
                                    value={dateInput}
                                    name="dateInput"
                                    pattern="\d{4}-\d{2}-\d{2}"
                                    type="date"
                                    max={this.getCurrentDate()}
                                    onChange={this.handleInputChange}
                                />
                                {/* Optional: Add error message for invalid format */}
                                {/* {submeet && !reg.test(dateInput) ? (
                    <ul className="parsley-errors-list filled" id="parsley-id-29">
                        <li className="parsley-required">
                            Please enter a valid date in YYYY-MM-DD format.
                        </li>
                    </ul>
                ) : null} */}
                            </div>

                            <div className="form-group">
                                <label>Birth Time</label>
                                <input
                                    className={`form-control ${!reg.test(birthTime) && submeet && "parsley-error"
                                        }`}
                                    value={birthTime}
                                    name="birthTime"
                                    // Assuming you want to validate date format
                                    pattern="\d{4}-\d{2}-\d{2}" // Date format validation pattern
                                    type="birthTime" // Change type to "date"
                                    onChange={(e) => {
                                        this.setState({ birthTime: e.target.value });
                                    }}
                                />
                                {/* {submeet && !reg.test(dateInput) ? (
      <ul className="parsley-errors-list filled" id="parsley-id-29">
        <li className="parsley-required">
          This value is required.
        </li>
      </ul>
    ) : null} */}
                            </div>
                            <div className="form-group">
                                <label>Address</label>
                                <textarea
                                    className={`form-control ${areaInput === "" && submeet && "parsley-error"
                                        }`}
                                    value={areaInput}
                                    cols="30"
                                    name="textarea"
                                    required=""
                                    rows="5"
                                    onChange={(e) => {
                                        this.setState({ areaInput: e.target.value });
                                    }}
                                ></textarea>
                                {areaInput === "" && submeet ? (
                                    <ul className="parsley-errors-list filled" id="parsley-id-29">
                                        <li className="parsley-required">
                                            This value is required.
                                        </li>
                                    </ul>
                                ) : null}
                            </div>
                            <div className="form-group">
                                <label>mobileNo No </label>
                                <input
                                    className={`form-control ${!reg.test(mobileNo) && submeet && "parsley-error"
                                        }`}
                                    value={mobileNo}
                                    name="mobileNo"
                                    pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$"
                                    // required=""
                                    type="number"
                                    onChange={(e) => {
                                        this.setState({ mobileNo: e.target.value });
                                    }}
                                />

                            </div>
                            <div className="form-group">
                                <label>Education</label>
                                <input
                                    className={`form-control ${!reg.test(education) && submeet && "parsley-error"
                                        }`}
                                    value={education}
                                    name="education"
                                    pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$"
                                    required=""
                                    type="text"
                                    onChange={(e) => {
                                        this.setState({ education: e.target.value });
                                    }}
                                />
                                {submeet && !reg.test(education) ? (
                                    <ul className="parsley-errors-list filled" id="parsley-id-29">
                                        <li className="parsley-required">
                                            This value is required.
                                        </li>
                                    </ul>
                                ) : null}
                            </div>
                            <div className="form-group">
                                <label>Sub Caste</label>
                                <select
                                    className="form-control"
                                    value={subcaste}
                                    name="subcaste"
                                    onChange={this.handleSubcasteChange}
                                >
                                    <option value="">{subcaste}</option>
                                    <option value="Kurmi">Kurmi</option>
                                    <option value="Patel">Patel</option>
                                    <option value="General">General</option>
                                    <option value="Other">Other</option>
                                    {/* Add more options for caste */}
                                </select>
                            </div>
                            <div className="form-group">
                                <label htmlFor="profession">Profession</label>
                                <select
                                    className={`form-control ${submeet && !profession && "parsley-error"
                                        }`}
                                    value={profession}
                                    name="profession"
                                    // required=""
                                    onChange={(e) => {
                                        this.setState({ profession: e.target.value });
                                    }}
                                >
                                    <option value="">Select</option>
                                    <option value="Doctor">Doctor</option>
                                    <option value="SoftwareEngineer">Software Engineer</option>
                                    <option value="GovernmentEmployee">Government Employee</option>
                                    <option value="Other">Other</option>

                                </select>
                                {/* {submeet && !profession ? (
                  <ul className="parsley-errors-list filled" id="parsley-id-29">
                    <li className="parsley-required">Deals With is required.</li>
                  </ul>
                ) : null} */}
                            </div>
                            <div className="form-group">
                                <label>Expectation</label>
                                <input
                                    className={`form-control ${!reg.test(expectation) && submeet && "parsley-error"
                                        }`}
                                    value={expectation}
                                    name="expectation"
                                    pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$"
                                    required=""
                                    type="text"
                                    onChange={(e) => {
                                        this.setState({ expectation: e.target.value });
                                    }}
                                />
                                {submeet && !reg.test(expectation) ? (
                                    <ul className="parsley-errors-list filled" id="parsley-id-29">
                                        <li className="parsley-required">
                                            This value is required.
                                        </li>
                                    </ul>
                                ) : null}
                            </div>
                            <div className="form-group">
                                <label>Per Annum</label>
                                <select
                                    className="form-control"
                                    value={perAnnum}
                                    name="perAnnum"
                                    onChange={this.handleperAnnumChange}
                                >
                                    <option value="">Select Income</option>
                                    <option value="lessthan3lac">Less than 3 lac</option>
                                    <option value="3lacto10lac">3lac-10lac</option>
                                    <option value="10lacto50lac">10lac-50lac</option>
                                    <option value="morethan50lac">More than 50lac</option>
                                    {/* Add more options for caste */}
                                </select>
                            </div>
                            <div className="form-group">
                                <label>Gotra</label>
                                <input
                                    className={`form-control ${!reg.test(gotra) && submeet && "parsley-error"
                                        }`}
                                    value={gotra}
                                    name="gotra"
                                    pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$"
                                    required=""
                                    type="text"
                                    onChange={(e) => {
                                        this.setState({ gotra: e.target.value });
                                    }}
                                />
                                {submeet && !reg.test(gotra) ? (
                                    <ul className="parsley-errors-list filled" id="parsley-id-29">
                                        <li className="parsley-required">
                                            This value is required.
                                        </li>
                                    </ul>
                                ) : null}
                            </div>
                            <div className="form-group">
  <label>Images</label>

  {/* Render new images or existing images correctly */}
  {(textInput.length > 0 ? currentImageUrls : existingImages).map((imageUrl, index) => (
    <div key={index}>
      <img 
        src={textInput.length > 0 ? imageUrl : `https://uma-classees.blr1.digitaloceanspaces.com/${imageUrl}`} 
        alt={`Image ${index}`} 
        style={{ width: '100px', marginBottom: '10px' }} 
      />
    </div>
  ))}

  <input
    type="file"
    className={`form-control ${!textInput.length && submeet && "parsley-error"}`}
    name="textInput"
    multiple
    onChange={this.handleChange}
  />
  {!textInput.length && submeet ? (
    <ul className="parsley-errors-list filled">
      <li className="parsley-required">This value is required.</li>
    </ul>
  ) : null}

  {errors.length > 0 && (
    <ul className="parsley-errors-list filled">
      {errors.map((error, index) => (
        <li key={index} className="parsley-required">{error}</li>
      ))}
    </ul>
  )}
</div>

                            <div className="form-group">
                                <label>City</label>
                                <input
                                    className={`form-control ${!reg.test(city) && submeet && "parsley-error"
                                        }`}
                                    value={city}
                                    name="city"
                                    pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$"
                                    required=""
                                    type="text"
                                    onChange={(e) => {
                                        this.setState({ city: e.target.value });
                                    }}
                                />
                                {submeet && !reg.test(city) ? (
                                    <ul className="parsley-errors-list filled" id="parsley-id-29">
                                        <li className="parsley-required">
                                            This value is required.
                                        </li>
                                    </ul>
                                ) : null}
                            </div>
                            <div className="form-group">
                                <label>State</label>
                                <select
                                    className="form-control"
                                    value={state}
                                    name="state"
                                    onChange={this.handleSateChange}
                                >
                                    <option value="">Select State</option>
                                    <option value="MadhyaPradesh">Madhya Pradesh</option>
                                    <option value="Meghalaya">Meghalaya</option>
                                    <option value="Kerela">Kerela</option>
                                    <option value="Punjab">Punjab</option>
                                    {/* Add more options for caste */}
                                </select>
                            </div>

                            <div className="form-group">
                                <label>Pincode</label>
                                <input
                                    type="number"
                                    className={`form-control ${textInput === "" && submeet && "parsley-error"
                                        }`}
                                    value={pinCode}
                                    name="number"
                                    required=""
                                    onChange={(e) => {
                                        this.setState({
                                            pinCode: e.target.value,
                                            submeet: false,
                                        });
                                    }}
                                />
                                {pinCode === "" && submeet ? (
                                    <ul className="parsley-errors-list filled" id="parsley-id-29">
                                        <li className="parsley-required">
                                            This value is required.
                                        </li>
                                    </ul>
                                ) : null}
                            </div>
                            <div className="form-group">
                                <label>About</label>
                                <textarea
                                    className={`form-control ${about === "" && submeet && "parsley-error"
                                        }`}
                                    value={about}
                                    cols="30"
                                    name="textarea"
                                    required=""
                                    rows="5"
                                    onChange={(e) => {
                                        this.setState({ about: e.target.value });
                                    }}
                                ></textarea>
                                {about === "" && submeet ? (
                                    <ul className="parsley-errors-list filled" id="parsley-id-29">
                                        <li className="parsley-required">
                                            This value is required.
                                        </li>
                                    </ul>
                                ) : null}
                            </div>

                            <div className="form-group">
                                <label htmlFor="bloodGroup">Select Packages</label>
                                <select
                                    className={`form-control ${submeet && !this.state.categoryId && "parsley-error"}`}
                                    value={this.state.categoryId || ''}
                                    name="category"
                                    required=""
                                    onChange={this.handleCategoryChange}
                                >
                                    <option value="" disabled>Select a category</option>
                                    {categoryData && categoryData.map((key) => (
                                        <option key={key.id} value={key.id}>{key.title}</option>
                                    ))}
                                </select>
                                {submeet && !this.state.categoryId ? (
                                    <ul className="parsley-errors-list filled" id="parsley-id-29">
                                        <li className="parsley-required">Category is required.</li>
                                    </ul>
                                ) : null}
                            </div>

                            {submissionStatus === 'success' && (
                                <div className="alert alert-success" role="alert">
                                    Form submitted successfully!
                                </div>
                            )}

                            <br />
                        </form>
                        <button
                            className="btn btn-primary"
                            onClick={(e) => {
                                // this.setState({ submeet: true });
                                this.handleSubmit(e)
                            }}
                        >
                            Submit
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({ mailInboxReducer }) => ({});
export default withRouter(EditMatrimony);
